import { Link } from "react-router-dom";

export function Error404Page() {
	return (
		<div className='min-h-screen flex items-center justify-center bg-[radial-gradient(circle_at_top,_#EAF6FF,_#FFFFFF_55%,_#F4F4F4_100%)] px-6 py-12 text-text-primary'>
			<div className='mx-auto flex w-full max-w-4xl flex-col items-center gap-8 rounded-[32px] border border-border bg-white/80 p-8 shadow-[0_20px_60px_rgba(15,23,42,0.12)] backdrop-blur sm:p-12'>
				<div className='flex items-center gap-4 rounded-full border border-border bg-white px-5 py-2 text-xs font-semibold uppercase tracking-[0.35em] text-text-tertiary'>
					En construcción
				</div>
				<div className='text-center'>
					<h1 className='text-3xl font-semibold sm:text-4xl'>
						Estamos afinando los detalles
					</h1>
					<p className='mt-3 max-w-xl text-base text-text-secondary'>
						Esta vista esta en desarrollo. Vuelve pronto para ver lo nuevo que
						estamos preparando.
					</p>
				</div>
				<div className='relative flex items-center justify-center'>
					<div className='absolute -z-10 h-40 w-40 rounded-full bg-secondary/60 blur-2xl' />
					<img
						src='/helmet.svg'
						alt='En construcción'
						className='h-24 w-24 object-contain breathing-icon'
					/>
				</div>
				<Link
					to='/'
					className='inline-flex items-center justify-center rounded-full bg-primary px-6 py-2 text-sm font-semibold text-white shadow-[0_10px_20px_rgba(0,142,185,0.25)] transition hover:bg-primary-hover'
				>
					Volver al landing
				</Link>
			</div>
		</div>
	);
}
